import React, { useEffect } from 'react'
import { FixedWrapper } from 'features/UserDeposits/Components/Success'
import { useHistory } from 'react-router-dom'

const Error = () => {
    const history = useHistory()

    useEffect(() => {
        let message = JSON.stringify({
            type: 'custom-event',
            status: 'error',
            url: window.location.href,
        })

        window.top.postMessage(message, '*')
        window.parent.postMessage(message, '*')
        history.push('/velkommen', {
            deposit: true,
            status: 'error',
            url: window.location.href,
        })
    }, [])

    return <FixedWrapper />
}

export default Error
